import { render, staticRenderFns } from "./DonationInfo.vue?vue&type=template&id=180de1aa"
import script from "./DonationInfo.vue?vue&type=script&lang=js"
export * from "./DonationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180de1aa')) {
      api.createRecord('180de1aa', component.options)
    } else {
      api.reload('180de1aa', component.options)
    }
    module.hot.accept("./DonationInfo.vue?vue&type=template&id=180de1aa", function () {
      api.rerender('180de1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/style-two/DonationInfo.vue"
export default component.exports